import { makeStyles } from '@material-ui/core'

const DynamicKeyPoints = ({ keyPoints }) => {
  const classes = useStyles()

  const getTitle = () => {
    return keyPoints?.name ? keyPoints?.name : 'Key Details'
  }
  return (
    <>
      <div className={classes.root}>
        <div className={classes.titleContainer}>
          <h2 className={classes.title}>{getTitle()}</h2>
        </div>
        <div className={classes.listWrapper}>
          {keyPoints?.keyPointDetails?.length
            ? keyPoints?.keyPointDetails?.map((keyDetail) => {
                return (
                  <div
                    className={classes.listItem}
                    key={`keyDetailHeading__${keyDetail?.heading?.fieldName}`}
                  >
                    <div className={classes.keyValueContainer}>
                      <div className={classes.heading}>
                        {keyDetail?.heading?.fieldName}
                      </div>
                      <div className={classes.value}>
                        {keyDetail?.heading?.fieldValue
                          ? keyDetail?.heading?.fieldValue
                          : 0}
                      </div>
                    </div>
                    <div className={classes.subHeadingListContainer}>
                      {keyDetail?.subHeadings?.map((subHeadingDataItem) => {
                        return (
                          <div
                            className={classes.keyValueContainer}
                            key={`keyDetailSubHeading__${subHeadingDataItem?.fieldName}`}
                          >
                            <div className={classes.subHeading}>
                              {subHeadingDataItem?.fieldName}
                            </div>
                            <div className={classes.value}>
                              {subHeadingDataItem?.fieldValue
                                ? subHeadingDataItem?.fieldValue
                                : 0}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                )
              })
            : 'No key details found'}
        </div>
      </div>
    </>
  )
}

export default DynamicKeyPoints

const useStyles = makeStyles({
  root: {
    height: '100%',
    maxHeight: '100%',
    overflow: 'auto',
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: '#333333',
    marginBottom: 'unset',
    padding: '5px',
  },
  listWrapper: { padding: '0px 20px' },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    padding: '16px',
    borderBottom: '1px solid #33333333',
    '&:last-child': {
      borderBottom: '0px solid #33333333',
    },
  },
  heading: {
    fontSize: '16px',
    color: '#333333',
    lineHeight: '16px',
    padding: '0 10px',
    textAlign: 'left',
  },
  keyValueContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '5px',
  },
  subHeadingListContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '20px',
  },
  subHeading: {
    fontSize: '14px',
    color: '#333333',
    lineHeight: '16px',
    padding: '0 10px',
    textAlign: 'left',
  },
  value: {
    fontSize: '16px',
    color: '#B92250',
    fontWeight: 'bold',
    lineHeight: '20px',
    textAlign: 'right',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  modalRoot: {
    height: '90%',
  },
})
